import { Route, Routes } from 'react-router-dom';
import AboutPage from './components/Pages/AboutPage';
import BlogPage from './components/Pages/BlogPage';
import BlogDetailsPage from './components/Pages/BlogDetailsPage';
import ContactPage from './components/Pages/ContactPage';
import ErrorPage from './components/Pages/ErrorPage';
import Home from './components/Pages/Home';
import PortfolioDetailsPage from './components/Pages/PortfolioDetailsPage';
import ServiceDetailsPage from './components/Pages/ServiceDetailsPage';
import SmartContract from './components/Pages/SmartContract';
import Webandmobiledevelopment from './components/Pages/webandmobiledevelopment';
import Telegramandbot from './components/Pages/Telegramandbot';
import Gamedevelopment from './components/Pages/Gamedevelopment';
import Dassetscreation from './components/Pages/3Dassets';
import Vrdevelopment from './components/Pages/Vrdevelopment'
import Uiuxdesining from './components/Pages/Uiuxdesining';
import Augmenteddevelopment from './components/Pages/Augmenteddevelopment';
import ServicesPage from './components/Pages/ServicesPage';
import PortfolioPage from './components/Pages/PortfolioPage';
import Layout from './components/Layout';
import Project from './components/Pages/Project';
import TeamPage from './components/Pages/TeamPage';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="projects" element={<Project />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="service" element={<ServicesPage />} />
          <Route path="our-team" element={<TeamPage />} />
          <Route
            path="service/dapp-development"
            element={<ServiceDetailsPage />}
          />
          <Route
            path="service/smart-contract"
            element={<SmartContract />}
          />
          <Route
            path="service/web-mobile-development"
            element={<Webandmobiledevelopment />}
          />
          <Route
            path="service/telegram-bot-apps-development"
            element={<Telegramandbot />}
          />
          <Route
            path="service/game-developemnt"
            element={<Gamedevelopment />}
          />
          <Route
            path="service/augmented-reality-development"
            element={<Augmenteddevelopment />}
          />
          <Route
            path="service/virtual-reality-development"
            element={<Vrdevelopment />}
          />
          <Route
            path="service/ui-ux-designing"
            element={<Uiuxdesining />}
          />
          <Route
            path="service/3d-assets-creation"
            element={<Dassetscreation />}
          />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route
            path="portfolio/:portfolioDetailsId"
            element={<PortfolioDetailsPage />}
          />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:blogDetailsId" element={<BlogDetailsPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;
